import { useState } from 'react';
import { api, errMsg } from '@/lib/api';
import { Panel } from '@/components/Common';
import { Button } from '@/components/ui/button';

const labels = {
  history_review_required: 'Doğrulanmış demo geçmişi henüz hazır değil.',
  insufficient_history: 'Tamamlanmış bir UTC günü henüz yok.',
  analytics_dependency_unavailable: 'QuantStats bağımlılığı kurulmamış veya uyumluluk kontrolü gerekli.',
  analytics_capacity_review_required: 'Ağır analiz için web sunucusunda yeterli bellek payı doğrulanamadı. Ayrı bulut hesaplama işçisi gerekli; emir ve fiyat akışı değiştirilmedi.',
  historical_report: 'Tarihsel hesap raporu · canlı bağlantı göstergesi değildir.',
};
const num = (v, suffix = '') => typeof v === 'number' && Number.isFinite(v)
  ? `${v.toLocaleString(undefined, { maximumFractionDigits: 3 })}${suffix}` : '—';

export default function BrokerPerformancePanel() {
  const [data, setData] = useState(null), [error, setError] = useState(''), [busy, setBusy] = useState(false);
  const load = async () => {
    if (busy) return;
    setBusy(true); setData(null); setError('');
    try {
      const { data: result } = await api.get('/local-mt5/execution/performance');
      if (!result || result.read_only !== true || result.execution_allowed !== false
          || result.real_allowed !== false || !Object.hasOwn(labels, result.status)
          || result.scope !== 'fixed_demo_account_all_deals'
          || result.basis !== 'daily_realized_balance_returns') throw new Error('PERFORMANCE_RESPONSE_INVALID');
      setData(result);
    } catch (e) { setError(errMsg(e)); }
    finally { setBusy(false); }
  };
  const m = data?.status === 'historical_report' ? data.metrics : null;
  return <Panel title="NEXUS PERFORMANCE · QUANTSTATS">
    <p className="text-sm text-muted-foreground">Sabit demo hesabı · masraflar dahil gerçekleşmiş bakiye getirisi. Manuel işlemler de dahildir; bot başarı oranı değildir. Açık pozisyonların kâr/zararı ve gün içi özkaynak düşüşü bu raporda yoktur.</p>
    <Button variant="outline" onClick={load} disabled={busy} className="my-3">{busy ? 'Rapor hazırlanıyor…' : 'Demo performans raporunu oku'}</Button>
    <p className="text-xs text-muted-foreground">Otomatik sorgu, ücretli model çağrısı veya emir gönderimi yapılmaz.</p>
    {error && <p role="alert" className="text-down mt-3">{error}</p>}
    {data && <div className="mt-3 space-y-2" role="status">
      <p>{labels[data.status]}</p>
      {data.as_of && <p className="text-xs text-muted-foreground">Geçmiş görüntüsü: {data.as_of} · {data.complete_days} tamamlanmış takvim günü · {num(data.snapshot_age_seconds, ' sn')} görüntü yaşı. Bugünün kısmi getirisi hariç.</p>}
      {m && <>
        <dl className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          <div><dt>Gerçekleşmiş getiri</dt><dd>{num(m.total_return_pct, '%')}</dd></div>
          <div><dt>Gün sonu bakiye düşüşü</dt><dd>{num(data.realized_drawdown_pct, '%')}</dd></div>
          <div><dt>Sharpe · 365 gün</dt><dd>{num(m.sharpe)}</dd></div>
          <div><dt>Sortino · 365 gün</dt><dd>{num(m.sortino)}</dd></div>
        </dl>
        {!m.ratios_sample_sufficient && <p className="text-xs text-muted-foreground">Oranlar için en az {m.minimum_ratio_days} gün gerekir; bu eşik kârlılık kanıtı değildir.</p>}
      </>}
      <p className="text-xs text-muted-foreground">Geçmiş performans gelecek kârı veya işlem hazırlığını kanıtlamaz. Gerçek hesap bu rapora dahil değildir.</p>
    </div>}
  </Panel>;
}
